import React from 'react'
import { KIND } from 'baseui/button'
import DefaultButton, { DefaultButtonSize, DefaultButtonType } from '@/components/DefaultButton'
import { SizeButton } from '@/constants/sizeButton'
import Icons from '../../../../Icons'

type ButtonKind = typeof KIND[keyof typeof KIND]

interface PopoverFullWidthButtonProps {
  kind: ButtonKind
  label: string
  onClick: () => void
  icon?: JSX.Element
  isPremium?: boolean
  disabled?: boolean
  size?: SizeButton
}

// KIND.primary → filled pink; anything else → filled grey. These map to the
// DefaultButton variants with matching fill/text tokens.
const TYPE_BY_KIND: Record<string, DefaultButtonType> = {
  [KIND.primary]: 'primary',
}

const SIZE_MAP: Record<SizeButton, DefaultButtonSize> = {
  [SizeButton.EXTRA_SMALL]: 'small',
  [SizeButton.SMALL]: 'small',
  [SizeButton.STANDARD]: 'standard',
  [SizeButton.LARGE]: 'large',
}

function PopoverFullWidthButton({
  kind,
  label,
  onClick,
  icon,
  isPremium,
  disabled,
  size = SizeButton.STANDARD,
}: PopoverFullWidthButtonProps) {
  // A premium action shows the premium badge; otherwise fall back to the
  // provided icon (e.g. the download / loading icon).
  const iconComponent =
    isPremium && icon ? (
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <Icons.PremiumIcon />
        {icon}
      </div>
    ) : isPremium ? (
      <Icons.PremiumIcon />
    ) : (
      icon
    )

  return (
    <DefaultButton
      type={TYPE_BY_KIND[kind] ?? 'secondary-grey'}
      size={SIZE_MAP[size]}
      label={label}
      onClick={onClick}
      disabled={disabled}
      fullWidth
      icon={iconComponent ? 'iconLeft' : 'noIcon'}
      iconComponent={iconComponent}
    />
  )
}

export default PopoverFullWidthButton
